import { combineReducers } from 'redux';

import applicationFlags from './applicationFlags';
import applications from './applications';
import auth from './auth';
import basket from './basket';
import emissionTypes from './emissionTypes';
import form from './form';
import initiativeEstimate from './initiativeEstimate';
import initiativeQuestionData from './initiativeQuestionData';
import invites from './invites';
import language from './language';
import payment from './payment';
import scroll from './scroll';
import staticProps from './staticProps';
import unitData from './unitData';
import whitelabel from './whitelabel';

export const reducers = {
  applications,
  applicationFlags,
  auth,
  basket,
  emissionTypes,
  scroll,
  form,
  invites,
  language,
  payment,
  whitelabel,
  initiativeEstimate,
  initiativeQuestionData,
  staticProps,
  unitData,
};

export default combineReducers(reducers);
